import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import { RentaDividendosNacionalModalComponent } from '../modales/renta-dividendos/renta-dividendos-nacional-modal/renta-dividendos-nacional-modal.component';
import { RentaDividendosExteriorModalComponent } from '../modales/renta-dividendos/renta-dividendos-exterior-modal/renta-dividendos-exterior-modal.component';
import { DDocumento } from '@dian/api-formulario';
import { HandlerComponent, Question } from '../handler-component';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { MessageObservableService } from '../../../../services/message-observable.service';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo

const questions:Question[] = [
  {question: '¿Usted tuvo ingresos por dividendos o participaciones?', field: 'cs_id_741', show:true, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: '¿Usted  tuvo ingresos por dividendos del exterior o ECE?', field: 'cs_id_746', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"}
];

@Component({
  selector: 'app-renta-dividendos',
  templateUrl: './renta-dividendos.component.html',
  styleUrls: ['./renta-dividendos.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class RentaDividendosComponent extends HandlerComponent implements OnInit {

  @Input('model') model: DDocumento = new DDocumento();
  @Output('isCompleted') isCompleted: EventEmitter<boolean> = new EventEmitter<false>();
  @Output('saveModel') saveModel: EventEmitter<boolean> = new EventEmitter<false>();

  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    private dialog: MatDialog,
    private _messagesObs: MessageObservableService

  ) { 
    super(questions);
  }

  ngOnInit() {
    this.initilizeQuestionsDesdeModelo(this.model);
    this.validateComponentCompleted();
  }

  validateQuestions(id: number) {
    console.log(id);

  }

  private listenMessagesObs() {
    this._messagesObs.getMessages().subscribe(res => {
      
    });
  }

  initilizeQuestionsDesdeModelo(model){
    for(let i=0; i<questions.length; i++){
      switch(i){
        case 0:
          questions[i].resp = this.model.doc.cuerpo.cs_id_741;  
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_741 != undefined && model.doc.cuerpo.cs_id_741 =="0") || (this.validateModalCompleted(i)));
          if(questions[i].isCompleted || model.doc.cuerpo.cs_id_741 == "1"){questions[i].show = true;}
          break;
        case 1:
          questions[i].resp = this.model.doc.cuerpo.cs_id_746;  
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_746 != undefined && model.doc.cuerpo.cs_id_746 =="0") || (this.validateModalCompleted(i)));
          if(questions[i].isCompleted || model.doc.cuerpo.cs_id_746 == "1"){questions[i].show = true;}
          break;
      }
      this.checkNextQuestion(i);
    }
    
  }

  openModal(indexQuestionModal:number) {
    const config = {
      minHeight: '80vh',
      minWidth: '80%',
      disableClose: true,
      data: this.model
    };
    switch (indexQuestionModal) {
      case 0:
        let dialog0 = this.dialog.open(RentaDividendosNacionalModalComponent, config);
        dialog0.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });
        dialog0.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
  
        break;
      case 1:
        let dialog1 = this.dialog.open(RentaDividendosExteriorModalComponent, config);
        dialog1.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });
        dialog1.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
    }
    
    
  }

  protected validateModalCompleted(indexQuestion:number):boolean{
    let isModalComplete:boolean = false;
    switch(indexQuestion){
      case 0://Modal 1
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_959, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 1://Modal 2
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_954, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      default:
        break;
    }
    if(isModalComplete){
      questions[indexQuestion].isCompleted = true;
      if(questions.length > indexQuestion+1) questions[indexQuestion + 1].show = true;//Habilitar visibilidad de la siguiente pregunta
    }else{
      questions[indexQuestion].isCompleted = false;
      //if(questions.length > indexQuestion+1) questions[indexQuestion + 1].show = false;
    }
    this.validateComponentCompleted();
    return isModalComplete;
  }
  
  /**
   * 
   * @param indexQuestion 
   * @returns verdadero si algún modal tiene valores.
   */
  protected validateHasModalValues(indexQuestion:number):boolean{
    let hasValues:boolean = false;
    switch(indexQuestion){
      case 0://Modal nacional
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_742, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_743, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_744, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_745, "0")){
          hasValues=true;break;
        }
        break;
      case 1://Modal extranjero
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_747, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_748, "0")){
          hasValues=true;break;
        }
        break;
     
      default:
        return false;
    }
    return hasValues;
  }
  protected cleanModalValues(indexQuestionModal:number){
    switch(indexQuestionModal){
      case 0:
       // this.model.doc.cuerpo.cs_id_741="0";
        this.model.doc.cuerpo.cs_id_742="0";
        this.model.doc.cuerpo.cs_id_743="0";
        this.model.doc.cuerpo.cs_id_744="0";
        this.model.doc.cuerpo.cs_id_745="0";
        this.model.doc.cuerpo.cs_id_959="0";//Indicador de Completo
        break;
      case 1:
        this.model.doc.cuerpo.cs_id_747="0";
        this.model.doc.cuerpo.cs_id_748="0";
        this.model.doc.cuerpo.cs_id_954="0";//Indicador de Completo
        break;
    }
    console.log(this.model);
  }

  public validateComponentCompleted(): boolean{
    for(let i=0; i < questions.length; i++){
      if(questions[i].isCompleted==false){
        this.isCompleted.emit(false);
        return false;
      }
    }
    this.isCompleted.emit(true);//Componente completo!
    return true;
  }

  changeValue(data: any, index: number) {
    questions[index].resp = data.value.toString();
    this.model.doc.cuerpo[data.field] = data.value.toString();
    if(this.model.doc.cuerpo[data.field] == "0"){
      if(this.validateHasModalValues(index)){
        this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
          if (result) {
            questions[index].isCompleted = true;
            this.cleanModalValues(index);
            this.validateComponentCompleted();
            this.saveModel.emit(true);
          }else{
            this.model.doc.cuerpo[data.field] == "";
          }
        });
      }else{
        questions[index].isCompleted = true;
        this.cleanModalValues(index);
        this.saveModel.emit(true);
      }
    }else if (this.model.doc.cuerpo[data.field] == "1"){
      questions[index].isCompleted = false;
      this.validateModalCompleted(index);//Valida antes de abrir el modal por si ya lo había completado para que siga mostrandolo completo
      this.openModal(index);
      this.saveModel.emit(true);
      
    }
    this.checkNextQuestion(index);
    this.validateComponentCompleted();
    console.log(data);
    console.log(this.model);
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/renta-dividendos/renta-dividendos.component.ts